const GENDERS = {
  H: 'male',
  M: 'female',
  male: 'H',
  female: 'M',
};

export { GENDERS };
